import React from "react";
import { IChildrenWrapperProps } from "../../interfaces/props/IChildrenWrapperProps";

/**
 * Компонент-обертка для children.
 * Если есть type.link === 'link' и href, то оборачивает children в Link.
 *
 * @param {IChildrenWrapperProps} props - Свойства компонента
 * @param {ReactNode} props.children - Любые React-элементы
 * @param {string} [props.href] - Ссылка. Если type.link === 'link'
 * @param {{link: string}} [props.type] - Тип. Если link === 'link', то оборачивает children в Link
 */
export function ChildrenWrapper(props: IChildrenWrapperProps): JSX.Element {
  const { children, href, type } = props;

  if (children === "undefined") return <></>;

  if (type?.link === "link" && href) {
    return (
      <a target="_blank" href={href} rel="noreferrer">
        {children}
      </a>
    );
  }

  return <div>{children}</div>;
}
